//@info creating custom hook foe navigation.

import { useNavigate } from 'react-router';

export const useNavigateTo = () => {
  const navigate = useNavigate();
  return (path) => navigate(path);
};